import type { UnknownObject } from '~/shared/interfaces'
import { isUnknownObject } from '~/shared/utils/guards'

export function unwrapData(body: unknown, key = 'data'): unknown {
  return isUnknownObject(body) ? body[key] : undefined
}

export function unwrapDataOrBody(body: unknown, key = 'data'): unknown {
  return unwrapData(body, key) ?? body
}

export function unwrapObject(body: unknown, key = 'data'): UnknownObject | null {
  const data = unwrapData(body, key)
  return isUnknownObject(data) ? data : null
}

export function mapToModels<T>(raw: unknown, modelCtor: new (data: unknown) => T): T[] {
  return Array.isArray(raw) ? raw.map(item => new modelCtor(item)) : []
}

export function unwrapToModels<T>(
  body: unknown,
  modelCtor: new (data: unknown) => T,
  key = 'data'
): T[] {
  return mapToModels(unwrapData(body, key), modelCtor)
}
